<script>
import OrderBot from "@/views/bots/views/Order.vue";

export default {
  name: "TailoringOrderBotPage",
  extends: OrderBot,
  props: {
    showPromotions: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    confirm() {
      if (Number(this.entity.paymentAmount || 0) < this.minPaymentAmount) {
        this.$toast.warning(
          `Мінімальна передплата для цього відшиву становить ${this.minPaymentAmount} грн.`
        );
        return;
      }

      this.isBlockSubmit = true;
      var path = window.location.origin + "/api/v1/order/create";
      this.$http
        .post(path, this.request)
        .then((response) => {
          this.entity = response.data.data;
          this.$route.params.id = this.entity.id;
          this.cashPaidAmount = response.data.data.totalCost;
          if (response.data.status) this.$toast.success("Відшив успішно створено");
          else this.$toast.error(response.data.message);

          this.isBlockSubmit = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message);
          this.isBlockSubmit = false;
        });
    },
    loadProductLookup({ append = false } = {}) {
      if (this.lookupLoading) {
        return Promise.resolve();
      }

      this.lookupLoading = true;
      const params = new URLSearchParams({
        page: this.lookupPagination.page,
        size: this.lookupPagination.packageSize,
        tailoringOnly: true,
        outOfStockOnly: true,
      });

      if (this.searchProduct) {
        params.set("search", this.searchProduct);
      }

      return this.$store
        .dispatch("get", {
          table: "productremains",
          method: "search?" + params.toString(),
        })
        .then((response) => {
          const data = response.data.data;
          this.lookupPagination = {
            ...data,
            entities: append
              ? this.mergeLookupEntities(
                this.lookupPagination.entities,
                data.entities ?? []
              )
              : data.entities ?? [],
          };
        })
        .finally(() => {
          this.lookupLoading = false;
        });
    },
    onLoadData(id) {
      const kind = "Wholesale";
      const fulfillmentKind = this.$route.query.fulfillmentKind || "Tailoring";
      return this.$store
        .dispatch("index", { table: "order", body: { id: id, kind, fulfillmentKind } })
        .then((response) => {
          var result = response.data;
          this.entity = result.data;
          this.entity.kind = "Wholesale";
          this.$route.params.id = this.entity.id;
          this.cashPaidAmount = result.data.totalCost;
          this.action = result.status ? "update" : "add";
          this.onSubLoadData(id);
        })
        .catch(() => {
          this.$toast.error(
            "Системна помилка. Не вдалось отримати інформацію."
          );
        });
    },
  },
};
</script>

<style scoped>
.flow-show {
  overflow-y: auto;
  max-height: calc(100dvh - 37px);
  padding-bottom: 2rem;
}

.product-add-form {
  display: grid;
  grid-template-columns: minmax(0, 1.8fr) minmax(180px, 0.9fr) auto;
  gap: 0.75rem;
  align-items: end;
  padding: 0.9rem 1rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: #f8f9fa;
}

.product-add-control {
  min-width: 0;
}

.product-add-button {
  min-width: 120px;
  height: 38px;
  white-space: nowrap;
}

.product-add-form :deep(.vs__dropdown-toggle) {
  min-height: 38px;
  height: 38px;
  border-color: #ced4da;
  background: #fff;
}

.product-add-form :deep(.vs__actions) {
  padding-right: 0.35rem;
}

.bot-order-page :deep(.bot-select-no-clear .vs__clear) {
  display: none;
}

.product-add-form :deep(.vs__selected-options) {
  flex-wrap: nowrap;
  overflow: hidden;
}

.product-add-form :deep(.vs__selected) {
  margin: 0;
}

.product-add-form :deep(.vs__search),
.product-add-form :deep(.vs__search:focus) {
  margin: 0;
}

.promotion-add-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.75rem;
  align-items: end;
  padding: 0.9rem 1rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: #f8f9fa;
}

.promotion-add-control {
  min-height: 38px;
  height: 38px;
  background: #fff;
}

.promotion-add-actions {
  display: flex;
}

.promotion-add-button {
  min-width: 120px;
  height: 38px;
  white-space: nowrap;
}

.bot-order-form :deep(.v-select) {
  width: 100%;
  min-height: 38px;
  text-align: left;
}

.bot-order-form :deep(.vs__dropdown-toggle) {
  min-height: 38px;
  height: 38px;
  border-color: #d9e2ec;
  border-radius: 8px;
  background: #ffffff;
}

.bot-order-form :deep(.vs__selected-options) {
  min-width: 0;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 0 8px;
}

.bot-order-form :deep(.vs__selected) {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bot-order-form :deep(.vs__search),
.bot-order-form :deep(.vs__search:focus) {
  margin: 0;
  padding: 0;
}

.bot-order-form :deep(.vs__actions) {
  align-items: center;
  height: 38px;
  padding: 0 8px 0 4px;
}

.bot-order-form :deep(.vs__open-indicator) {
  display: block;
}

@media (max-width: 767.98px) {
  .bot-order-page {
    padding-left: 12px;
    padding-right: 12px;
  }

  .bot-order-form {
    padding: 12px;
  }

  .product-add-form {
    grid-template-columns: 1fr;
    padding: 0.75rem 0.9rem;
  }

  .product-add-button {
    width: 100%;
  }

  .promotion-add-form {
    grid-template-columns: 1fr;
    padding: 0.75rem 0.9rem;
  }

  .promotion-add-button {
    width: 100%;
  }

  .bot-order-form .form-control,
  .bot-order-form :deep(.vs__selected),
  .bot-order-form :deep(.vs__search),
  .bot-order-form :deep(.vs__search:focus),
  .bot-order-form :deep(.vs__dropdown-option) {
    font-size: 16px;
  }
}
</style>
